<template>
  <div>
    <v-app-bar
        app
        color="black"
        height="80"
        dark
    >
      <LocalizedLink class="routerLink" to="/" max-height="60px" style="position:relative;">
        <v-img
            src="../assets/amiguetes-logo-new.png"
            height="60px"
            width="184px"
            class="d-none d-sm-flex"
        ></v-img>
        <v-img
            src="../assets/amiguetes-logo-new.png"
            height="40px"
            width="130px"
            class="d-flex d-sm-none"
        ></v-img>
      </LocalizedLink>

      <a class="routerLink" href="https://x.com/anandasociety">
        <v-icon
            role="img"
            size="33"
            class="mr-4"
        >
          mdi-twitter
        </v-icon>
      </a>

      <a class="routerLink" href="https://www.instagram.com/ananda_society">
        <v-icon
            role="img"
            size="33"
            class="mr-4"
        >
          mdi-instagram
        </v-icon>
      </a>

      <v-spacer></v-spacer>

      <!--<template >
        <v-col
            :key="'nav-home'"
            class="text-no-wrap d-none d-lg-block"
            cols="auto"
        >

          <v-list-item>
              <LocalizedLink
                  class="routerLink"
                  to="/home"
              >

                <v-icon
                    role="img"
                    size="33"
                    class="mr-4"
                >mdi-home</v-icon>

              <strong>Escritorio</strong>
            </LocalizedLink>
          </v-list-item>

        </v-col>
      </template>-->

      <NavProfile class="hidden-md-and-down"></NavProfile>

      <template >
        <v-col
            v-for="(links, i) in $t('navPrivate')"
            :key="'nav-'+i"
            class="text-no-wrap d-none d-lg-block"
            cols="auto"

        >
          <div style="position:relative;"
          v-if="!links.onlyForAdmin || isAdmin === true">

            <LocalizedLink
                class="routerLink"
                :to="links.to"
            >

              <v-badge
                  color="green"
                  :content="unreadMessages > 9 ? '9+' : unreadMessages"
                  left
                  overlap
                  v-if="links.badge && unreadMessages > 0"
              >
                <v-icon
                    role="img"
                    size="33"
                    class="mr-4"
                    v-text="links.icon"
                ></v-icon>
              </v-badge>

              <v-icon
                  v-else
                  role="img"
                  size="33"
                  class="mr-4"
                  v-text="links.icon"
              ></v-icon>


              <strong v-text="links.text"></strong>
            </LocalizedLink>

          </div>
        </v-col>
      </template>

      <v-col
          class="text-no-wrap d-none d-lg-block"
          cols="auto"
      >

        <a class="routerLink hidden-md-and-down"
           @click="logout"
        >

          <v-icon
              role="img"
              size="33"
              class="mr-4"
          >
            mdi-logout
          </v-icon>

          <strong>{{$t("login.logout")}}</strong>

        </a>

      </v-col>

      <!--<v-col
          v-for="(links, i) in $t('landing.navLanguages')"
          :key="'languages'+i"
          class="text-no-wrap d-none d-lg-block"
          cols="auto"

      >
        <div>

          <v-avatar
              class="mr-4 outlined"
              v-bind:class="[!dropdownMenuLanguage ? 'language-default' : 'language-open', 'mr-4 outlined']"
              size="33"
              @click="dropdownMenuLanguage = !dropdownMenuLanguage"
          >
            <v-icon
                role="img"
                size="20"
                class="text-center"
                v-text="links.icon"
                color="white"
            >
            </v-icon>
          </v-avatar>

          <template >
            <div style="position:absolute;right:15px">

              <v-fab-transition
                                v-for="subLink in links.subLinks"
                                :key="subLink.text"
                                absolute
                                fab
                                bottom
                                right
              >

                <v-list-item

                    v-model="$i18n.locale"
                    @click="changeLocale(subLink.locale)"
                    v-show="dropdownMenuLanguage"
                >
                    <v-list-item-icon>
                      <v-icon>{{ subLink.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ subLink.text }}</v-list-item-title>
                </v-list-item>
              </v-fab-transition>
            </div>
          </template>
        </div>
      </v-col>-->

      <v-app-bar-nav-icon
          class="d-flex d-lg-none d-xl-none"
          @click="drawer = true">
      </v-app-bar-nav-icon>

    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      fixed
      temporary
      right
      dark
  >
    <v-list
        nav
        dense
    >
      <!--<v-list-item>
        <LocalizedLink to="/home" class="d-flex v-list-item v-list-item--link theme--dark px-0">
          <v-list-item-icon>
            <v-icon
                role="img"
                size="33"
                class="mr-4"
            >mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-title >Escritorio</v-list-item-title>
        </LocalizedLink>
      </v-list-item>-->

      <NavProfile drawer="true"></NavProfile>

      <div
          class="deep-purple--text text--accent-4"
          v-for="({ icon, text, to, badge, subLinks, onlyForAdmin }, i) in $t('navPrivate')"
          :key="i"
      >

        <v-list-item
            v-if="!subLinks && (!onlyForAdmin || isAdmin === true)"
            :key="i"
        >
          <LocalizedLink v-if="typeof to !== 'undefined'" :to="to" class="d-flex v-list-item v-list-item--link theme--dark px-0">
            <v-list-item-icon>
              <v-badge
                  color="green"
                  :content="unreadMessages > 9 ? '9+' : unreadMessages"
                  left
                  overlap
                  v-if="badge && unreadMessages > 0"
              >
                <v-icon
                    role="img"
                    size="33"
                    class="mr-4"
                    v-text="icon"
                ></v-icon>
              </v-badge>

              <v-icon
                  v-else
                  role="img"
                  size="33"
                  class="mr-4"
                  v-text="icon"
              ></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="text"></v-list-item-title>
          </LocalizedLink>

        </v-list-item>

        <v-list-group
            v-else-if="subLinks"
            :key="text"
            no-action
            :prepend-icon="icon"
            :value="false"
        >
          <template v-slot:activator>
            <v-list-item-title>{{ text }}</v-list-item-title>
          </template>

          <v-list-item
              v-for="subLink in subLinks"
              :to="subLink.to"
              :key="subLink.text"
              v-model="$i18n.locale"
              @click="changeLocale(subLink.locale)"
          >
            <v-list-item-icon>
              <v-icon>{{ subLink.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ subLink.text }}</v-list-item-title>

          </v-list-item>

        </v-list-group>

      </div>

      <v-list-item
          class="hidden-lg-and-up routerLink"
          @click="logout"
      >
        <v-list-item-icon>
          <v-icon size="33">mdi-logout</v-icon>
        </v-list-item-icon>

        <v-list-item-title class="ml-3">Logout</v-list-item-title>
      </v-list-item>

    </v-list>
  </v-navigation-drawer>
  </div>
</template>

<script>
import LocalizedLink from "@/components/LocalizedLink"
import NavProfile from "@/components/NavProfile"
import { getSupportedLocales } from "@/util/i18n/supported-locales"
import "../css/nav.css";
import Session from "../services/Session";
import store from "../store/index.js";
import Cross from "@/services/Cross.js"

export default {
  data: () => ({
    drawer: false,
    isAdmin: false,
    dropdownMenuLanguage: false,
    unreadMessages: 0,
    intervalId: null,
    locales: getSupportedLocales()
  }),
  props: ["to"],
  methods: {
    changeLocale(value) {
      this.$router.push(`/${value}`)
    },
    logout(){
      Session.logout()
      store.dispatch('logout').then(()=> {
        this.$router.push({'name': 'Login'})
      })
    },
    loadUnReadMessages(){
      if(this.$store.state.tokenStored) {
        Cross.unread(this.$store.state.tokenStored).then((response) => {
          this.loader = false

          if (!response || response.success === false) {
            return
          }

          this.unreadMessages = response.messages
        })
      }
    }
  },
  components: { LocalizedLink, NavProfile },
  created(){
    this.isAdmin = Session.getSessionParam('isAdmin') === true
    let obj = this
    this.intervalId = setInterval(function(){
      obj.loadUnReadMessages()
    }, 60000);
  },
  beforeDestroy(){
    window.clearInterval(this.intervalId);
  }
}
</script>